import { useContext } from 'react';
import { Context } from './userProvider';

export const useUser = () => useContext(Context).state;
